import React from 'react';

import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Checkbox,
  Typography,
  Divider,
  Space,
  Popconfirm,
  message,
  Modal,
  Tooltip,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const Extra = () => {
  return (
    <Tooltip title="These fields are the same for all forms, the data can be entered when filling out the form.">
      <InfoCircleOutlined />
    </Tooltip>
  );
};

const InitDetails = () => {
  return (
    <Card
      title="Initial Details"
      style={{
        marginBottom: 24,
        width: '100%',
        boxSizing: 'border-box',
        padding: '0',
      }}
      extra={<Extra />}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item label="Created By" required style={{ marginBottom: 10 }}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Created At" required style={{ marginBottom: 10 }}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Asset Type" required style={{ marginBottom: 10 }}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Select Asset"
              required
              style={{ marginBottom: 10 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="VIN" required style={{ marginBottom: 10 }}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Client" style={{ marginBottom: 10 }}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Mileage" required style={{ marginBottom: 10 }}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Engine Hours"
              required
              style={{ marginBottom: 10 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
export default InitDetails;
